import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useSetSubscriptionLimits } from '../useSetSubscriptionLimits';
import { useSwitchOptimizerTabs } from './useChangeOptimizerTabs';

import { editorTypes } from '../../../components/common/tiptapEditor/constants/tiptapEditorConstants';
import { selectCurrentEditorVersion } from '../../../components/common/tiptapEditor/store/tiptapEditor.selectors';
import useOutlineVersions from '../../../components/common/tiptapEditor/hooks/outline/useOutlineVersions';
import { setAIContentLoadingField } from '../../../components/pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.actions';
import { selectAIContentLoadingField } from '../../../components/pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.selectors';

import {
    isCurrentAiProcessFinished,
    isCurrentAiProcessInProgress,
    showAiResultMessage,
} from '../../helpers/aiOptimizerHelpers';

export const useTrackProgressAIOutline = () => {
    const dispatch = useDispatch();
    const { updateSubscriptionLimits } = useSetSubscriptionLimits();
    const { switchToOptimizerOutlineTab } = useSwitchOptimizerTabs();

    const editorType = editorTypes.OUTLINE;
    const currentEditorVersion = useSelector(selectCurrentEditorVersion(editorType));
    const aiContentLoadingField = useSelector(selectAIContentLoadingField);
    const [showAiStatusMessage, setShowAiStatusMessage] = useState(false);

    const isAiOutlineInProgress = useMemo(() => {
        return (
            !!currentEditorVersion &&
            isCurrentAiProcessInProgress(currentEditorVersion.generation_status)
        );
    }, [currentEditorVersion]);

    const { fetchOutlineVersions } = useOutlineVersions();

    useEffect(() => {
        if (
            !isAiOutlineInProgress &&
            aiContentLoadingField === editorType &&
            currentEditorVersion &&
            showAiStatusMessage
        ) {
            const { generation_status } = currentEditorVersion;

            if (isCurrentAiProcessFinished(generation_status)) {
                showAiResultMessage(generation_status, editorType);
                setShowAiStatusMessage(false);
                updateSubscriptionLimits();
                switchToOptimizerOutlineTab();
            }
        }
        // eslint-disable-next-line
    }, [aiContentLoadingField, isAiOutlineInProgress, showAiStatusMessage, currentEditorVersion]);

    useEffect(() => {
        if (isAiOutlineInProgress) {
            setShowAiStatusMessage(true);
            dispatch(setAIContentLoadingField(editorType));

            const interval = setInterval(() => {
                fetchOutlineVersions(false);
            }, 1000 * 5);

            return () => {
                clearInterval(interval);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAiOutlineInProgress]);
};
